module.exports = __webpack_public_path__ + "img/img-10c46c.png";